import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_mst_item_event_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.VarcharDatatypeInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_doc_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  doc_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mkp_mst_item_event_Rowclass implements bl_mkp_mst_item_event_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.VarcharDatatypeInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_doc_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  doc_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}